import React from 'react';
import { FaCheck } from 'react-icons/fa';
import { WIZARD_STEPS_AGENCY_PROFILE  } from '../../../utils/agencyProfileConstants'; // Adjust path

const CDProfileWizard = ({ currentStep }) => (
    <div className="wizard-container">
        <div className="step-indicator-wrapper">
            <div className="step-progress-track"></div>
            <div className="step-progress-fill" style={{ width: `${(currentStep / (WIZARD_STEPS_AGENCY_PROFILE.length - 1)) * 92}%` }}></div>
            {WIZARD_STEPS_AGENCY_PROFILE .map((step, index) => (
                <div key={step.id} className={`step-item ${index === currentStep ? 'active' : ''} ${index < currentStep ? 'completed' : ''}`}>
                    <div className="step-circle">{index < currentStep ? <FaCheck /> : index + 1}</div>
                    <div className="step-label">{step.title}</div>
                </div>
            ))}
        </div>
    </div>
);

export default CDProfileWizard;